import { FC } from "react";
import moment from "moment";
import generalSvg from "../../../utils/svg-icon/general";

const PublishedDate: FC<{ date: string; className?: string }> = ({
    date,
    className = "",
}) => {
    const { FileLine } = generalSvg;
    return (
        <span className={className}>
            <FileLine /> {moment(date).format("MMMM, d YYYY")}
        </span>
    );
};

export default PublishedDate;
